// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "assets/" + (chunkId === 85 ? "lazy-app" : chunkId) + "." + {"85":"ad28bbb6f2a436f3cbed","371":"3c37944e395ffdb19820"}[chunkId] + ".js";
};